<div id="fadeShare"></div>
<div id="modalShare">
  <img style="margin-bottom: 10px" id="loader" src="/Cache/images/icon_load.gif" /><br />
  <label>Please wait while the page is processing...</label>
</div>
<app-global-spinner></app-global-spinner>

<router-outlet></router-outlet>

<!-- TODO: Need to resolve issue with multiples spinners -->
<div id="fade"></div>
<div id="modal">
  <img style="margin-bottom: 10px" id="loader" src="/Cache/images/icon_load.gif" /><br />
  <label style="color: black"><strong>Please wait ...</strong></label>
</div>
